var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("checking...")]),_c('CAlert',{directives:[{name:"show",rawName:"v-show",value:(_vm.showError),expression:"showError"}],attrs:{"color":"danger"}},[_vm._v(_vm._s(_vm.errorMessage))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }